import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import PageSection from '../../../../../../features/components/PageSection'

import { formatNumberToShort } from '../../../../helpers'
import { generateStakeholderData } from './helpers'
import { useSroiReportCurrencySymbol } from '../../../hooks'
import { formatNumber } from '../../../../../../helpers/numbers'
import HoverHelpTextIcon from '../../../../../../features/components/HoverHelpTextIcon'

import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'

import { helpTexts } from '../../../constants'

import usePanelsStyles from '../styles'
import useStyles from './styles'

const StakeholdersCountPanel = () => {
  const { t } = useTranslation()

  const panelsClasses = usePanelsStyles()
  const classes = useStyles()

  const {
    stakeholder_count: stakeholderCount,
    categorical_impact: categoricalImpact,
    impact_per_stakeholder: impactPerStakeholder
  } = useSelector(socialReturnOnInvestmentReportSelector)

  const stakeholderData = generateStakeholderData(categoricalImpact)
  const currencySymbol = useSroiReportCurrencySymbol()

  const formattedStakeholderCount = useMemo(() => {
    //   If Stakeholders < 100,000 then show exact value
    if (stakeholderCount < 100000) {
      return formatNumber(stakeholderCount, 0)
    } else {
      return formatNumberToShort(stakeholderCount, 2)
    }
  }, [stakeholderCount])

  const formattedImpactPerStakeholder = useMemo(() => {
    // If Impact per stakeholder < 100,000 then show exact value
    if (impactPerStakeholder < 100000) {
      return formatNumber(impactPerStakeholder, 2)
    } else {
      return formatNumberToShort(impactPerStakeholder, 2)
    }
  }, [impactPerStakeholder])

  return (
    <PageSection className={classnames(panelsClasses.panel, classes.stakeholdersPanel)}>
      <div className={classnames(panelsClasses.leftSide, classes.totalsColumn)}>
        <h5 className={panelsClasses.valueTitle}>
          {t('Stakeholders')} <HoverHelpTextIcon helpText={helpTexts.stakeholders} />
        </h5>
        <div className={panelsClasses.value}>{formattedStakeholderCount}</div>
        <h5 className={panelsClasses.valueTitle}>{t('Total')}</h5>
        <h5 className={panelsClasses.valueTitle}>{t('Impact per stakeholder')}</h5>
        <div className={panelsClasses.subValue}>
          {currencySymbol} {formattedImpactPerStakeholder}
        </div>
      </div>
      <div className={classnames(panelsClasses.rightSide, classes.stakeholdersColumn)}>
        {stakeholderData.map(stakeholder => (
          <div key={stakeholder.id} className={classes.stakeholdersColumnItem}>
            <div className={classes.stakeholderLabel}>{stakeholder.name}</div>
            <div className={classes.stakeholderValue}>{formatNumber(stakeholder.count, 0)}</div>
          </div>
        ))}
      </div>
    </PageSection>
  )
}

export default StakeholdersCountPanel
